module.exports = {
	"title": {
		"artist": "Qobuzで{アーティスト名}を聴く",
		"album": "{アーティスト名}の{アルバム名}をQobuzで聴く",
		"track": "{アーティスト名}の{曲名}をQobuzで聴く",
		"playlist": "{オーナー名}の{プレイリスト名}をQobuzで聴く",
		"story": "Qobuzに関するこの記事を読む"
	},
	"buttons": {
		"listen": "Qobuzで聴く",
		"buy": "購入",
		"share": "シェアする",
		"download": "無料で試す",
		"readmore": "もっと読む",
		"showless": "詳細を閉じる",
		"showmore": "もっと見る",
		"morealbums": "Qobuzで他のアルバムを見る",
		"moreplaylisttrack": "Qobuzで他の作品を発見する",
		"readfocus": "このパノラマをQobuzで読む",
		"seeSubscribes": "サブスクリプションオファーを見る",
		"cookies": "Cookie設定"
	},
	"infos": {
		"trackCount": "{数}曲",
		"label": "レーベル：{レーベル}",
		"composer": "作曲家：{作曲家}",
		"producers": "制作",
		"mixers": "ミックス／マスタリング",
		"diskCount": "{数}アルバム",
		"duration": {
			"long": "{時}h{分}m",
			"short": "{分}m{秒}s"
		},
		"playlist": {
			"private": "非公開",
			"public": "公開"
		},
		"hires": "高音質",
		"available": "利用可能"
	},
	"share": {
		"twitter": {
			"track": "{アーティスト}の{タイトル}をQobuzで聴く",
			"album": "{アーティスト}の{タイトル}をQobuzで聴く",
			"artist": "Qobuzで{アーティスト名}を聴く",
			"playlist": "{オーナー名}の{プレイリスト名}をQobuzで聴く",
			"story": "Qobuzでこの記事を読む"
		},
		"mail": {
			"track": {
				"subject": "{アーティスト}の{タイトル}がQobuzでご利用できます！",
				"body": "{アーティスト}の{タイトル}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"album": {
				"subject": "{アーティスト}の{タイトル}がQobuzでご利用できます！",
				"body": "{アーティスト}の{タイトル}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"artist": {
				"subject": "{アーティスト}がQobuzで聴けます！",
				"body": "{アーティスト}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"playlist": {
				"subject": "{オーナー名}の{プレイリスト}がQobuzでご利用できます！",
				"body": "{オーナー名}の{プレイリスト}を高品質でQobuzで聴く：{url}\n\nQobuzは、高音質で音楽のストリーミングとダウンロードができる初のサービスです\n詳細および登録はQobuz.comをご覧ください\n\n"
			},
			"story": {
				"subject": "{title}",
				"body": "{url}を読むには\n\nQobuzは、高音質ストリーミングとダウンロードのパイオニアサービスです。\n詳細と登録はQobuz.com\n\n"
			}
		},
		"popup": {
			"clickToCopy": "クリックでコピー",
			"copy": "コピー",
			"copied": "コピーされました",
			"link": "シェアするには以下のリンクをコピーしてください"
		}
	},
	"tracklist": {
		"title": {
			"track": "曲",
			"album": "アルバム曲",
			"artist": "トップ曲",
			"artist_albums": "アルバム",
			"playlist": "プレイリストの曲"
		},
		"header": {
			"number": "#",
			"name": "曲",
			"album": "アルバム",
			"artist": "アーティスト",
			"time": "再生時間",
			"label": "レーベル"
		},
		"media_count": "CD {メディアナンバー}",
		"noTracks": "利用可能な楽曲はありません"
	},
	"story": {
		"404": {
			"title": "リクエストされたアイテムは、お住まいの地域には存在しません。",
			"description": "Qobuzマガジンのホームに戻る"
		},
		"from": "執筆 {author}",
		"albumOverlay": " - {releaseYear} - {genre}",
		"joinQobuz": "Qobuz に参加して記事全文を読む...",
		"signUp": "無料でお試しください"
	},
	"playlist": {
		"from": "執筆 {author}"
	},
	"album": {
		"by": "の",
		"publishedBy": "のリリース"
	},
	"notifications": {
		"nostream": "権利者の都合により、この曲の試聴はできません"
	},
	"aside": {
		"title": "詳細"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/ja.json
// module id = 568
// module chunks = 0